module.exports = __webpack_public_path__ + "media/images/skull2-67b6b419c4bb6b758d337d4b1331097d.png";